import {
    FlexGap,
    StackVertical,
} from "@twigsby/frontend-framework";
import React, {useEffect, useRef} from 'react';
import {useTranslation} from "@twigsby/frontend-framework";
import {AccountHeader} from "../Components/Account/AccountHeader";
import GetInTouch from "../Components/Content/GetInTouch";
import {GuidedTour} from "../Components/GuidedTour";
import ActivityFeed from "../Components/Overview/ActivityFeed";
import TipBlock from "../Components/Overview/TipBlock";
import {UserAccountAllowance} from "../Components/User/UserAccountAllowance";
import {UserAccountIssues} from "../Components/User/UserAccountIssues";
import {UserAccountStats} from "../Components/User/UserAccountStats";
import {useSite} from "../Providers/SiteInterfaceProvider";

const Overview = () => {
    const { t } = useTranslation();
    const{ currentLocale, updatePageMeta } = useSite();

    const overviewContainer = useRef<any>();

    useEffect(() => {
        updatePageMeta({
            title: t('overviewPage.title')
        });
    }, [currentLocale]);

    return (
        <div className='content-main content-area-narrow' ref={overviewContainer}>
            <div className={'container-narrow pt-sm pb-sm'}>
                <StackVertical gap={FlexGap.ExtraLarge}>
                    <AccountHeader />

                    <div>
                        <UserAccountIssues />
                        <UserAccountAllowance />
                    </div>

                    <div className={'row'}>
                        <div className={'col-xs-12'}>
                            <UserAccountStats />
                        </div>
                    </div>

                    <div className={'row'}>
                        <div className={'col-xs-12 col-lg-8 mb-lg'}>
                            <ActivityFeed ref={overviewContainer} />
                        </div>
                        <div className={'col-xs-12 col-lg-4'}>
                            <h6 className={'sub-heading mb-xs'}>{t('overviewPage.labels.misc')}</h6>
                            <StackVertical extraClass={'sticky'} gap={FlexGap.Medium}>
                                <TipBlock title={t('overviewPage.labels.tips')} />
                                <GetInTouch />
                            </StackVertical>
                        </div>
                    </div>

                    <GuidedTour />

                </StackVertical>
            </div>
        </div>
    );
};

export default Overview;
